import { render, staticRenderFns } from "./main.vue?vue&type=template&id=fe1bdbea&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=fe1bdbea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../nodejs_workspace/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1bdbea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/pix/Documents/dev/wedia/wedia/war/nodejs_workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe1bdbea')) {
      api.createRecord('fe1bdbea', component.options)
    } else {
      api.reload('fe1bdbea', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=fe1bdbea&scoped=true&", function () {
      api.rerender('fe1bdbea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/javascript/bov3/js/vue/components/wedia/wxm-el-tree/src/main.vue"
export default component.exports